<template>
  <v-dialog
    v-model="isOpened"
    persistent
    scrollable
    width="400px"
  >
    <v-card>
      <v-card-title class="pa-0">
        <v-toolbar color="primary darken-1" dark>
          <v-toolbar-title>Supprimer un domaine</v-toolbar-title>
          <v-spacer />
          <v-btn text icon color="white" @click="isOpened = false">
            <v-icon>clear</v-icon>
          </v-btn>
        </v-toolbar>
      </v-card-title>
      <v-card-text class="pa-3">
        <v-row>
          <v-col align="center" class="black--text subtitle-1 pb-0">
            <span>Voulez-vous supprimer le domaine</span>
          </v-col>
        </v-row>
        <v-row>
          <v-col align="center" class="black--text subtitle-1 pa-0">
            <span class="font-weight-bold">{{ this.domain.name }} ?</span>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn text @click="isOpened = false">Annuler</v-btn>
        <v-btn :disabled="!$canWrite" color="primary darken-1" :loading="isSaving" @click="$canWrite && (submit($event))">Supprimer</v-btn>
        <v-spacer/>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: `DeleteDomain`,
  props: [`value`, `domain`],
  data: () => ({
    name: ``,
    isSaving: false,
  }),
  computed: {
    isOpened: {
      get() { return this.value; },
      set(value) { this.$emit(`input`, value); },
    },
  },
  methods: {
    async submit() {
      this.isSaving = true;
      await this.$store.dispatch(`model/domain/deleteDomain`, this.domain);
      this.isSaving = false;
      this.isOpened = false;
      this.$emit(`delete`);
    },
  },
};
</script>
